import * as React from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParam = (paramName: string): string | null => {
  const { search } = useLocation();

  return React.useMemo(() => {
    const params = new URLSearchParams(search);

    return params.get(paramName);
  }, [paramName, search]);
};
